import React, { useEffect, useState } from "react";
import { Accordion, Badge, Row, Col, Button, Card, Container, Form, Modal, Spinner } from 'react-bootstrap';
import { FaArrowLeft, FaChalkboardTeacher, FaUsers, FaUserGraduate,FaImage,FaVideo,FaBookOpen,FaBook,FaCheck  } from 'react-icons/fa';
import useDayPlan from "./tables/dayPlan/useDayPlan";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import "./dayPlan.css";
import { usePostLessonMutation } from "slices/get/lesson";
import useService from "views/default/useService";
import { ModalShowImages, ModalShowVideos } from "./modelDayplanImagesAndVideos";
import CommonTableFilters from "commonFilterComponent/commonFilterComponent";
import DatePicker from 'react-datepicker';
import { usePostCommonMutation } from "slices/get/common";
import { format } from "date-fns";

// Generate Random Light Colors
const getRandomColor = () => {
  const colors = ["#FFB6C1", "#FFD700", "#98FB98", "#87CEFA", "#FF69B4", "#FFA07A", "#AFEEEE", "#DDA0DD"];
  return colors[Math.floor(Math.random() * colors.length)];
};

const DayPlan = () => {
  const [filters, setFilters] = useState({}); // 👈 maintain filters in state
  const { title, description, data, tableInstance, } = useDayPlan(filters); 
  const { refresh, loader } = tableInstance;// 👈 call hook here ONCE
  const handleFilterChange = (updatedFilters) => {
    setFilters(updatedFilters); // 👈 triggers useEffect inside useHomework
  };
  const [selectedKey, setSelectedKey] = useState("");
  const [showModal, setShowModal] = useState(false);

  const keyLabels = {
    homework: "Homework",
    conclusion: "Conclusion",
    studentWillDo: "Student Will Do"
  };
const [isEditHomework, setIsEditHomework] = useState(false);
const [homeworkDate, setHomeworkDate] = useState(null);
const [homeworkDateError, setHomeworkDateError] = useState(false);
 const openModal = (key) => {
  setSelectedKey(key);
  setShowModal(true);
  setIsEditHomework(false); // reset
  setHomeworkDate(null);
  setHomeworkDateError(false);
};

  const closeModal = () => {
    setSelectedKey("");
    setShowModal(false);
  };
  const history = useHistory();
  const [uploadedImages, setUploadedImages] = useState({});
   const { checkAccessTime, fetchAccessToken } = useService();
  const [postLesson] = usePostLessonMutation();
   const location = useLocation();
    const currentPath = location.pathname;
  const access_token = fetchAccessToken();
  // const [successMessage, setSuccessMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false)
const [selectedImages, setSelectedImages] = useState(null); // State for selected images
  const [selectedVideos, setSelectedVideos] = useState(null); // State for selected videos
  const [showImageModal, setShowImageModal] = useState(false); // State for showing image modal
  const [showVideoModal, setShowVideoModal] = useState(false); // State for showing video modal
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

//   let enrichedData =  data.map((each) => {return {
//   ...each,
//   lessonTitle: 'this is the sample title',
//   lessonType: 'I Do',
//   homework : "please complete all this by the end of this data",
//   titleAndImagesData: [
//           {
//             title: 'Nature Collection',
//             image1: 'https://picsum.photos/id/1018/200/150',
//             image2: 'https://picsum.photos/id/1025/200/150',
//             image3: 'https://picsum.photos/id/1035/200/150',
//           },
//           {
//             title: 'Urban Scenes',
//             image1: 'https://picsum.photos/id/1043/200/150',
//             image2: 'https://picsum.photos/id/1050/200/150',
//             image3: 'https://picsum.photos/id/1062/200/150',
//             image4: 'https://picsum.photos/id/1076/200/150',
//             image5: 'https://picsum.photos/id/1084/200/150',
//           },
//         ],
//   titleAndUrlsData: [
//     {
//       title: 'Tutorial Series',
//       url1: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
//       url2: 'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
//       url3: 'https://www.youtube.com/watch?v=lTTajzrSkCw',
//     },
//     {
//       title: 'Music Videos',
//       url1: 'https://www.youtube.com/watch?v=Zi_XLOBDo_Y',
//       url2: 'https://www.youtube.com/watch?v=kXYiU_JCYtU',
//       url3: 'https://www.youtube.com/watch?v=2vjPBrBU-TM',
//       url4: 'https://www.youtube.com/watch?v=09R8_2nJtjg',
//       url5: 'https://www.youtube.com/watch?v=fLexgOxsZu0',
//     },
//   ],
// }
// })

  const lessonTypes = [
    { type: 'I Do', icon: <FaChalkboardTeacher />, color: 'primary' },
    { type: 'We Do', icon: <FaUsers />, color: 'success' },
    { type: 'You Do', icon: <FaUserGraduate />, color: 'warning' },
  ];


  // Open image modal and set related images
  const handleImageIconClick = (images) => {
    setSelectedImages(images);
    setShowImageModal(true);
        // history.push('/view-plan-images', { images: images });
    // setShowImageModal(true);
  };
    const handleVideoIconClick = (videos) => {
    setSelectedVideos(videos);
    setShowVideoModal(true);
  };
  // Handle Image Upload
  const handleImageUpload = (event, lessonId, index) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedImages((prev) => {
        const updatedImages = prev[lessonId] ? [...prev[lessonId]] : [];
        updatedImages[index] = file; // Maintain correct order
        return { ...prev, [lessonId]: updatedImages };
      });
    }
  };

  // Handle "Mark as Completed"
  // const handleCompleteLesson = (lessonPlanId,lessonId,schoolId,seriesId,standardId,subjectId) => {
  //   const files = uploadedImages[lessonPlanId] ? uploadedImages[lessonPlanId].filter(Boolean) : []; // Remove empty slots
  //   // Simulate API call
  //   const formData = new FormData();
  //   formData.append("lessonPlanId", lessonPlanId);
  //   formData.append("lessonId", lessonId);
  //   formData.append("schoolId", schoolId);
  //   formData.append("seriesId", seriesId);
  //   formData.append("standardId", standardId);
  //   formData.append("subjectId", subjectId);
  //   formData.append("completed", true);
  //   files.forEach((file, index) => {
  //     formData.append(`file${index + 1}`, file);
  //   });
  //   formData.append("fileCount", files.length);

  //   // Example: Send to API
  //   postLesson({ ep: '/school/teacher_plan', formData, token: access_token }).then((response) => {
  //     if (response.data && response.data.status) {
  //       setSuccessMessage(response.data);
  //       setIsSuccess(true);
  //       setTimeout(()=>{
  //         // onCloseAddModal();
  //         // window.location.reload()
  //       },[2000])
  //       // onCloseAddModal(response.data)
  //     } else {
  //       setSuccessMessage(response.data);
  //       setIsSuccess(true);
  //     }

  //     checkAccessTime(response, currentPath);

     
  //   });
  // }
  // const handleCompleteLesson = (lessonPlanId, lessonId, schoolId, seriesId, standardId, subjectId) => {
  //   const files = uploadedImages[lessonPlanId] || {}; // Get the uploaded images
  
  //   const formData = new FormData();
  //   formData.append("lessonPlanId", lessonPlanId);
  //   formData.append("lessonId", lessonId);
  //   formData.append("schoolId", schoolId);
  //   formData.append("seriesId", seriesId);
  //   formData.append("standardId", standardId);
  //   formData.append("subjectId", subjectId);
  //   formData.append("completed", true);
  
  //   // Append only updated files with correct keys
  //   Object.entries(files).forEach(([index, file]) => {
  //     if (file) {
  //       formData.append(`file${parseInt(index) + 1}`, file); // Ensure correct file key (file1, file2, file3)
  //     }
  //   });
  
  //   formData.append("fileCount", Object.keys(files).length);
  
  //   // API Call
  //   postLesson({ ep: "/school/teacher_plan", formData, token: access_token }).then((response) => {
  //     if (response.data && response.data.status) {
  //       setSuccessMessage(response.data);
  //       setIsSuccess(true);
  //       setTimeout(() => {
  //         // onCloseAddModal();
  //         refresh()
  //       }, 1000);
  //     } else {
  //       setSuccessMessage(response.data);
  //       setIsSuccess(true);
  //     }
  
  //     checkAccessTime(response, currentPath);
  //   });
  // };
  useEffect(() => {
  if (successMessage || errorMessage) {
    const timer = setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [successMessage, errorMessage]);
const [submitLoading, setSubmitLoading] = useState(false);
const [popupMessage, setPopupMessage] = useState(null);
const [popupError, setPopupError] = useState(false);
 const [postCommon] = usePostCommonMutation();
const handleSendHomework = async (homework) => {
  // 🔴 Date validation (MANDATORY)
  // if (!homeworkDate) {
  //   setPopupMessage("Please select a date before sending homework");
  //   setPopupError(true);
  //   return;
  // }

  try {
    setSubmitLoading(true);
    setPopupMessage(null);
    setPopupError(false);

    const schoolData = JSON.parse(localStorage.getItem("school_data"));
    const { standardId, subjectId, seriesId, lessonId, sectionId } = filters;

    const values = {
      series_id: seriesId,
      school_id: schoolData?.[0]?.id,
      standard_id: standardId,
      subject_id: subjectId,
      lesson_id: lessonId,
      section_id: sectionId,
      date: format(new Date(), 'yyyy/MM/dd'),
      homework: homework,
      active: 'on',
    };

    const response = await postCommon({
      ep: "/standard/home_work_submit",
      values,
      token: access_token,
    });

    if (response?.data?.status) {
      // ✅ SUCCESS
      setPopupMessage("Homework sent successfully");
      setPopupError(false);

      setTimeout(() => {
         setPopupMessage(null);
         setPopupError(false);
      }, 1000);
    } else {
      // ❌ API returned failure
      setPopupMessage(response?.data?.message || "Failed to send homework");
      setPopupError(true);
    }

  } catch (error) {
    // ❌ API / Network error
    setPopupMessage("Something went wrong. Please try again.");
    setPopupError(true);
  } finally {
    setSubmitLoading(false);
  }
};

  const handleCompleteLesson = async (
  lessonPlanId,
  lessonId,
  schoolId,
  seriesId,
  standardId,
  subjectId
) => {
  try {
    setIsLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    const files = uploadedImages[lessonPlanId] || {};
    const formData = new FormData();

    formData.append("lessonPlanId", lessonPlanId);
    formData.append("lessonId", lessonId);
    formData.append("schoolId", schoolId);
    formData.append("seriesId", seriesId);
    formData.append("standardId", standardId);
    formData.append("subjectId", subjectId);
    formData.append("completed", true);
    formData.append("section_id", filters.sectionId);   

    Object.entries(files).forEach(([index, file]) => {
      if (file) {
        formData.append(`file${parseInt(index) + 1}`, file);
      }
    });

    formData.append("fileCount", Object.keys(files).length);

    const response = await postLesson({
      ep: "/school/teacher_plan",
      formData,
      token: access_token,
    });

    checkAccessTime(response, currentPath);

    if (response?.data?.status) {
      setSuccessMessage(response.data.message || "Lesson completed successfully ✅");
      refresh();
    } else {
      setErrorMessage(response?.data?.message || "Something went wrong ❌");
    }
  } catch (error) {
    setErrorMessage(
      error?.response?.data?.message || "Server error. Please try again ❌"
    );
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="dayplan-container">
      <Row className="justify-content-center text-center mb-4">
        <Col xs={12}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <FaArrowLeft className="cursor-pointer text-primary" size={24} onClick={() => history.goBack()} />
            <h2 className="small-title flex-grow-1 text-center mt-2">Lesson Plan</h2>
          </div>
        </Col>
         <CommonTableFilters onFilterChange={handleFilterChange} />
      </Row>
      {filters?.subjectId && (
        <Row className="mb-4 justify-content-center">
          <Col xs={12} md={4} lg={3} className="mb-3 mb-md-0">
            <Card className="text-center shadow-sm border-0">
              <Card.Body className="py-3" style={{ background: 'linear-gradient(135deg, #4e73df, #1cc88a)', color: '#fff', borderRadius: '0.5rem' }}>
                <h5 className="mb-0">
                  Total Lessons (
                  {filters?.totalLessons != null ? filters.totalLessons : '-'}
                  )
                </h5>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4} lg={3}>
            <Card className="text-center shadow-sm border-0">
              <Card.Body className="py-3" style={{ background: 'linear-gradient(135deg, #f6c23e, #e74a3b)', color: '#fff', borderRadius: '0.5rem' }}>
                <h5 className="mb-0">
                  Total Plans (
                  {filters?.totalPlans != null ? filters.totalPlans : '-'}
                  )
                </h5>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      {loader ? (
        <div className="dayplan-loader">
          <Spinner animation="border" variant="primary" />
          <p className="dayplan-loader-text">Loading lesson plans...</p>
        </div>
      ) : data.length === 0 ? (
        <div className="dayplan-empty">
          <div className="dayplan-empty-icon">📘</div>
          <h4 className="dayplan-empty-title">Lesson Plans Not Found</h4>
          <p className="dayplan-empty-text">
            Try changing the filters above to view available lesson plans.
          </p>
        </div>
      ) : (
   <Accordion className="crazy-accordion">
        {data.map((lesson, index) => (
          <Accordion.Item eventKey={String(index)} key={index}>
         <Accordion.Header style={{ backgroundColor: lesson.is_completed == 1 ? 'green' : 'gray' }}>
  <div className="w-100 d-flex flex-column flex-md-row align-items-center justify-content-between">

    {/* Left side: Icons and lesson type */}
    <div className="d-flex align-items-center gap-3 order-2 order-md-1">
      <div style={{ display: "flex", alignItems: "center" }}>
        <FaBookOpen className="icon" style={{ color: "black", marginLeft: "5px", width: "20px" }} />
        <span className="day-text" style={{ color: "black", marginLeft: "5px" }}>{lesson.day}</span>
      </div>
      <Badge
        bg={
          lesson.lessonType === 'I Do'
            ? 'primary'
            : lesson.lessonType === 'We Do'
            ? 'success'
            : 'warning'
        }
        className="d-flex align-items-center gap-1 px-2 py-1"
      >
        {lesson.lessonType === 'I Do' && <i className="bi bi-person-fill fs-3"></i>}
        {lesson.lessonType === 'We Do' && <i className="bi bi-people-fill fs-3"></i>}
        {lesson.lessonType === 'You Do' && <i className="bi bi-person fs-3"></i>}
      </Badge>
      <small className="text-muted color-black">
        <span className="lesson-type-badge">{lesson.lessonType}</span>
      </small>
    </div>

    {/* Center: Title */}
    <div className="flex-grow-1 text-center order-1 order-md-2">
      <h5 className="mb-0">{lesson.lessonTitle}</h5>
    </div>

    {/* Right: Date */}
    <div className="order-3 text-md-end text-start">
      {lesson.is_completed == 1 && (
        <h5 style={{ color: "black", margin: 0 }}>{lesson.date}</h5>
      )}
    </div>
  </div>
</Accordion.Header>


            <Accordion.Body>
                              
        
         
         
            {/* <Accordion.Item eventKey={String(index)} key={lesson.id} className="crazy-accordion-item"> */}
             {/* <Accordion.Header className="lesson-accordion-header" style={{ backgroundColor: lesson.is_completed == 1 ? 'green' : 'gray' }}>
              <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FaBookOpen className="icon" style={{ color: "black", marginLeft: "5px", width: "20px" }} />
                  <span className="day-text" style={{ color: "black", marginLeft: "5px" }}>{lesson.day}</span>
                </div>

                {lesson.is_completed == 1 && (
                  <span style={{ color: "black", marginLeft: "auto", textAlign: "right",marginRight:'5px' }}>
                    {lesson.date}
                  </span>
                )}
              </div>
            </Accordion.Header> */}
            <Accordion.Body className="accordion-body">
                <div className="lesson-card" style={{ backgroundColor: "#ffffff" }}>
                {/* <h2 className="lesson-plan">
                  <div>
                  <strong>{lesson.plan.split("\n")[0].trim()}</strong>
                  <br />
                  <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                    {lesson.plan
                      .split("\n")
                      .slice(1) 
                      .map((line, index) =>
                        line.trim() ? (
                          <li key={index} style={{ marginBottom: "5px" }}>
                            {line.trim()}
                          </li>
                        ) : null
                      )}
                  </ul>
                </div>
              </h2> */}
                      <div className="mb-4">
                {/* <h6 className="fw-bold mb-3">Image Galleries</h6> */}
                  <div className="d-flex justify-content-center">
      <Row className="g-4" style={{ maxWidth: '1200px', width: '100%' }}>
        
        {/* Image Galleries Column */}
        <Col md={12}>
  <div className="gallery-section">
    <Row className="g-3">
      {lesson.titleAndImagesData?.map((section, idx) => (
        <Col md={6} key={idx}>
          <div className="p-3 rounded h-100">

            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              {section.title
                .split("\n")
                .map(
                  (line, index) =>
                    line.trim() && (
                      <li
                        key={index}
                        style={{
                          marginBottom: "5px",
                          fontWeight: 700,
                          fontSize: "16px",
                        }}
                      >
                        {line.trim()}
                      </li>
                    )
                )}
            </ul>

            {Object.values(section).some(
              (val) => typeof val === "string" && val.startsWith("http")
            ) && (
              <Button
                variant="outline-primary"
                onClick={() =>
                  handleImageIconClick(
                    Object.values(section).filter(
                      (val) =>
                        typeof val === "string" && val.startsWith("http")
                    )
                  )
                }
                className="d-flex align-items-center gap-2 mt-2"
              >
                <FaImage size={20} />
                <span>Show Images</span>
              </Button>
            )}
          </div>
        </Col>
      ))}
    </Row>
  </div>
</Col>
        {/* Video Galleries Column */}
        {/* <Col md={6} className="d-flex justify-content-center">
          <div className="gallery-section">
            <div className="d-flex flex-column gap-3">
              {lesson.titleAndUrlsData?.map((section, idx) => (
                <div key={idx}>
                                 <div>
   <ul style={{ listStyleType: "none" }}>
                      {section.title
                        .split("\n")
                        .slice(0)
                        .map((line, index) =>
                          line.trim() ? (
                            <li key={index} style={{ marginBottom: "5px", fontWeight: 700,fontSize:"16px" }}>
                              {line.trim()}
                            </li>
                          ) : null
                        )}
                    </ul>
</div>
                 {Object.values(section).some(
  (val) => typeof val === 'string' && val.startsWith('http')
) && (
  <Button
    variant="outline-success"
    onClick={() =>
      handleVideoIconClick(
        Object.values(section).filter(
          (val) => typeof val === 'string' && val.startsWith('http')
        )
      )
    }
    className="video-icon-btn d-flex align-items-center gap-2" style={{marginLeft:"30px"}}
  >
    <FaVideo size={20} />
    <span>Show Videos</span>
  </Button>
)}

                </div>
              ))}
            </div>
          </div>
        </Col> */}
          <Col md={12}>
  <div className="gallery-section">
    <Row className="g-3">
      {lesson.titleAndUrlsData?.map((section, idx) => (
        <Col xs={12} md={6} key={idx}>
          <div className="p-3 rounded h-100">

            {/* Title */}
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              {section.title
                .split("\n")
                .map(
                  (line, index) =>
                    line.trim() && (
                      <li
                        key={index}
                        style={{
                          marginBottom: "5px",
                          fontWeight: 700,
                          fontSize: "16px",
                        }}
                      >
                        {line.trim()}
                      </li>
                    )
                )}
            </ul>

            {/* Show Videos Button */}
            {Object.values(section).some(
              (val) => typeof val === "string" && val.startsWith("http")
            ) && (
              <Button
                variant="outline-success"
                onClick={() =>
                  handleVideoIconClick(
                    Object.values(section).filter(
                      (val) =>
                        typeof val === "string" && val.startsWith("http")
                    )
                  )
                }
                className="d-flex align-items-center gap-2 mt-2"
              >
                <FaVideo size={20} />
                <span>Show Videos</span>
              </Button>
            )}
          </div>
        </Col>
      ))}
    </Row>
  </div>
</Col>
      </Row>
    </div>

      {/* {lesson?.homework && <div className="mb-4"> */}
      {/* Homework Header with Icon */}
      {/* <Card className="mb-3 mt-3">
        <Card.Body className="d-flex align-items-center">
          <FaBook size={24} style={{ marginRight: 16, color: '#007bff' }} />
          <h5 className="m-0">Homework :  {lesson?.homework || 'No homework assigned.'} </h5>
        </Card.Body>
      </Card> */}

      {/* Homework Content */}
      {/* <Card className="bg-light">
        <Card.Body>
          <p>{lesson?.homework || 'No homework assigned.'}</p>
        </Card.Body>
      </Card> */}
    {/* </div>} */}
    {/* <div className="container mt-4">

      <div className="d-flex gap-3">

        {lesson.homework && lesson.homework.trim() !== "" && (
          <button className="btn btn-primary" onClick={() => openModal("homework")}>
            Homework
          </button>
        )}

        {lesson.conclusion && lesson.conclusion.trim() !== "" && (
          <button className="btn btn-success" onClick={() => openModal("conclusion")}>
            Conclusion
          </button>
        )}

        {lesson.studentWillDo && lesson.studentWillDo.trim() !== "" && (
          <button className="btn btn-warning" onClick={() => openModal("studentWillDo")}>
            Student Will Do
          </button>
        )}

      </div>

      {showModal && (
       <Modal show={showModal} onHide={closeModal} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>{keyLabels[selectedKey]}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
      {lesson[selectedKey]}
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={closeModal}>
      Cancel
    </Button>
  </Modal.Footer>
</Modal>
      )}

    </div> */}
      <div className="container mt-4">

  {/* Buttons Row */}
  <div className="d-flex flex-column flex-md-row gap-3">
{lesson.studentWillDo && lesson.studentWillDo.trim() !== "" && (
      <button
        className="btn btn-warning w-100 w-md-auto"
        onClick={() => openModal("studentWillDo")}
      >
        Student Will Do
      </button>
    )}
    {/* Homework Button */}
    

    {/* Conclusion Button */}
    {lesson.conclusion && lesson.conclusion.trim() !== "" && (
      <button
        className="btn btn-success w-100 w-md-auto"
        onClick={() => openModal("conclusion")}
      >
        Conclusion
      </button>
    )}

    {lesson.homework && lesson.homework.trim() !== "" && (
      <button
        className="btn btn-primary w-100 w-md-auto"
        onClick={() => openModal("homework")}
      >
        Homework
      </button>
    )}

    {/* Student Will Do Button */}
    

  </div>

  {/* Modal */}
 {showModal && (
  <Modal show={showModal} onHide={closeModal} size="xl" centered>
    <Modal.Header closeButton>
      <Modal.Title>{keyLabels[selectedKey]}</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      {/* Homework Content */}
      <div
        style={{
          whiteSpace: "pre-wrap",
          lineHeight: "1.5",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        {lesson[selectedKey]}
      </div>

      {/* Edit Homework Button */}
      {/* {selectedKey === "homework" && !isEditHomework && (
        <div className="mt-4 text-end">
          <Button
            variant="warning"
            onClick={() => setIsEditHomework(true)}
          >
            Edit Homework
          </Button>
        </div>
      )} */}

      {/* Date Picker Section */}
      {/* {selectedKey === "homework" && isEditHomework && (
        <div className="mt-4">
          <label className="form-label">Select Homework Date</label>

          <DatePicker
            selected={homeworkDate}
            onChange={(date) => {
              setHomeworkDate(date);
              setHomeworkDateError(false);
            }}
            dateFormat="yyyy/MM/dd"
            placeholderText="Select Date"
            className="form-control"
          />

          {homeworkDateError && (
            <div className="text-danger mt-1">
              Please select a date
            </div>
          )}
        </div>
      )} */}
      {(popupMessage && selectedKey === "homework") && (
  <div
    className={`alert ${
      popupError ? "alert-danger" : "alert-success"
    } mt-3`}
    role="alert"
  >
    {popupMessage}
  </div>
)}

    </Modal.Body>

    <Modal.Footer>
      {selectedKey === "homework" && (
      <Button
  variant="primary"
  onClick={()=>handleSendHomework(lesson[selectedKey])}
  disabled={submitLoading}
>
  {submitLoading ? "Sending..." : "Send Homework"}
</Button>
      )}
      <Button variant="secondary" onClick={closeModal}>
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
)}


</div>
              </div>



                
                </div>
              </Accordion.Body>
            {/* </Accordion.Item> */}
            <div className="image-upload-section">
                  {[0, 1, 2].map((imageIndex) => {
                    const existingImage = lesson[`file${imageIndex + 1}`];
                    const newImage = uploadedImages[lesson.id]?.[imageIndex];

                    return (
                      <div key={imageIndex} className="image-upload">
                       

                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(event) => handleImageUpload(event, lesson.id, imageIndex)}
                        />
                         {newImage ? (
                          <img src={URL.createObjectURL(newImage)} alt="Uploaded" className="preview-image" />
                        ) : existingImage ? (
                          <img src={existingImage} alt={`Uploaded ${imageIndex + 1}`} className="preview-image" />
                        ) : null}
                      </div>
                    );
                  })}
                </div>



                  <div className="d-flex justify-content-end mt-3">
                    <Button variant="success" onClick={() => handleCompleteLesson(lesson.id,lesson.lesson_id,lesson.school_id,lesson.series_id,lesson.standard_id,lesson.subject_id)}>
                      <FaCheck className="me-2" /> Mark as Completed
                    </Button>
                  </div>
        {successMessage && (
          <div className="alert alert-success mt-3" role="alert">
            {successMessage}
          </div>
        )}

        {errorMessage && (
          <div className="alert alert-danger mt-3" role="alert">
            {errorMessage}
          </div>
        )}
     
              {/* Image Galleries Section */}
            
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      )}

      {/* Modal to show images */}
      <ModalShowImages
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        dataList={selectedImages}
      />

      {/* Modal to show videos */}
      <ModalShowVideos
        show={showVideoModal}
        onHide={() => setShowVideoModal(false)}
        dataList={selectedVideos}
      />
      {/* <Accordion className="lesson-accordion">
        {data.map((lesson, index) => {
          const bgColor = lesson.is_completed == 1 ? 'green' : 'gray';
          return (
            <Accordion.Item eventKey={String(index)} key={lesson.id} className="lesson-accordion-item">
              <Accordion.Header className="lesson-accordion-header" style={{ backgroundColor: bgColor }}>
              <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FaBookOpen className="icon" style={{ color: "white", marginLeft: "5px", width: "20px" }} />
                  <span className="day-text" style={{ color: "white", marginLeft: "5px" }}>{lesson.day}</span>
                </div>

                {lesson.is_completed == 1 && (
                  <span style={{ color: "white", marginLeft: "auto", textAlign: "right",marginRight:'5px' }}>
                    {lesson.date}
                  </span>
                )}
              </div>
            </Accordion.Header>

              <Accordion.Body className="accordion-body">
                <div className="lesson-card" style={{ backgroundColor: getRandomColor() }}>
                <h2 className="lesson-plan">
                  <div>
                  <strong>{lesson.plan.split("\n")[0].trim()}</strong>
                  <br />
                  <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                    {lesson.plan
                      .split("\n")
                      .slice(1) 
                      .map((line, index) =>
                        line.trim() ? (
                          <li key={index} style={{ marginBottom: "5px" }}>
                            {line.trim()}
                          </li>
                        ) : null
                      )}
                  </ul>
                </div>
              </h2>




                  <div className="image-upload-section">
                  {[0, 1, 2].map((imageIndex) => {
                    const existingImage = lesson[`file${imageIndex + 1}`];
                    const newImage = uploadedImages[lesson.id]?.[imageIndex];

                    return (
                      <div key={imageIndex} className="image-upload">
                       

                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(event) => handleImageUpload(event, lesson.id, imageIndex)}
                        />
                         {newImage ? (
                          <img src={URL.createObjectURL(newImage)} alt="Uploaded" className="preview-image" />
                        ) : existingImage ? (
                          <img src={existingImage} alt={`Uploaded ${imageIndex + 1}`} className="preview-image" />
                        ) : null}
                      </div>
                    );
                  })}
                </div>



                  <div className="d-flex justify-content-end mt-3">
                    <Button variant="success" onClick={() => handleCompleteLesson(lesson.id,lesson.lesson_id,lesson.school_id,lesson.series_id,lesson.standard_id,lesson.subject_id)}>
                      <FaCheck className="me-2" /> Mark as Completed
                    </Button>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion> */}
    </div>
  );
};

export default DayPlan;
